import route from '../router/index'
export const samplings = [
  {text: "1 minuto", value: '1', order: 1},
  {text: "15 minuti", value: '15', order: 2},
  {text: "60 minuti", value: '60', order: 3},
  {text: "Giornaliero", value: 'd', order: 4},
  //{text: "Settimanale", value: 'w'},
  {text: "Mensile", value: 'm', order: 5},
  {text: "Annuale", value: 'y', order: 6}, 
];

export function getSamplings() {
  return samplings;
  /*
  if(route.currentRoute.name !== 'Charts' && samplings.length > 5) {
    samplings.shift()
    return [...samplings]
  }
  if(route.currentRoute.name === 'Charts' && samplings.length < 6)
    samplings.unshift({text: "1 minuto", value: '1'})
    return [...samplings]
    */
}

// ['d', '60', 'w'] returns 'w'
export const getMinSampling = (samplingsForSearching) => {
  const samplings = getSamplings();
  let index = 0;

  samplingsForSearching.forEach((searchSampling) => {
    const samplingIndex = samplings.findIndex(
      (samplings) => samplings.value === searchSampling
    );

    if (index < samplingIndex) {
      index = samplingIndex;
    }
  });

  return samplings[index].value;
}

export const getDisabledByMin = (minSampling) => {
  return getSamplings()
    .filter((sampling) => sampling.value !== getMinSampling([minSampling, sampling.value]))
    .map((sampling) => sampling.value);
}



// WEBPACK FOOTER //
// ./src/helpers/measure.js